import React from 'react';

import css from './SubTitle.module.scss';

export type SubTitleProps = {
    text: string;
    customClass?: string;
};

const SubTitle = ({ text, customClass }: SubTitleProps) => {
    return (
        <div>
            <div className={`${css.tfa_subtitle} ${customClass || ''}`}>{text}</div>
        </div>
    );
};

export default SubTitle;
